import { ChallengeInfoForAdmin, ReqCreateOrUpdateChallenge } from '@types';
import {
  ChallengeFormType,
  ConverterData2Form,
  ConverterForm2Data,
} from '../../NewChallengeForm.types';

export const convertForm2Data: ConverterForm2Data<
  Pick<ChallengeFormType, 'title'>,
  Pick<ReqCreateOrUpdateChallenge, 'title'>
> = ({ title }) => {
  if (!title?.length) throw Error("[TitleForm] this shouldn't be happened");

  return { title };
};

export const convertData2Form: ConverterData2Form<
  Pick<ChallengeInfoForAdmin, 'title'>,
  Pick<ChallengeFormType, 'title'>
> = ({ title }) => ({ title });
